import React from 'react';
import styled from 'styled-components';
import { useRecommendations } from '@algolia/recommend-react';
import recommend from '@algolia/recommend';
import { LocalizedLink } from '@repo/gatsby-localization-helpers';
import type { SanitySupportArticle } from '@repo/models/gatsby-graphql-types';

const ArticleList = styled.ul`
  list-style-type: none;
  padding: 0;
`;

const ArticleLink = styled(LocalizedLink)`
  color: ${({ theme }) => theme.colors.supportArticleLink};
  text-decoration: none;

  :hover {
    color: ${({ theme }) => theme.colors.linkHover};
  }
`;

const ListItem = styled.li`
  border-bottom: 1px solid ${({ theme }) => theme.colors.searchBorder};
  padding: 1em 0 1em 0;
  margin-left: 0;
`;

const recommendClient = recommend(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

interface RelatedSupportArticlesProps {
  article: SanitySupportArticle;
  indexName: string;
}

function RelatedSupportArticles({
  article,
  indexName,
}: Readonly<RelatedSupportArticlesProps>) {
  const { recommendations } = useRecommendations(
    {
      model: 'related-products',
      recommendClient,
      indexName,
      objectIDs: [article?._id?.replace('drafts.', '')],
      maxRecommendations: 5,
    },
    [article?._id]
  );

  return (
    recommendations && (
      <ArticleList>
        {recommendations.map(recommendation => (
          <ListItem key={recommendation.objectID}>
            <ArticleLink to={recommendation.link}>
              {recommendation.title}
            </ArticleLink>
          </ListItem>
        ))}
      </ArticleList>
    )
  );
}

export default RelatedSupportArticles;
